import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import InvoiceMenu from "./InvoiceMenu";
import MonthsDropDown from "../Shared/MonthsDropDown";
import YearsDropDown from "../Shared/YearsDropDown";

function AddInvoice() {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [validated, setValidated] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [hasError, setHasError] = useState(false);
    const [loading, setLoading] = useState(false);
    const todayDate = new Date().toISOString().slice(0, 10);

    let navigate = useNavigate();

    const handleSubmit = (event) => {

        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            setLoading(true);
            const data = {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                SelectedMonth: parseInt(event.target.InvoiceMonth.value),
                FYear: parseInt(event.target.InvoiceYear.value),
                InvoiceAmount: parseInt(event.target.InvoiceAmount.value),
                InvoiceStatus: event.target.InvoiceStatus.value,
                PaymentStatus: event.target.PaymentStatus.value,
                GeneratedDate: event.target.GeneratedDate.value,
                AdminRemarks: event.target.AdminRemarks.value,
                SchoolID: 1,
            };

            //console.log(data);

            var api_config = {
                method: 'post',
                url: config.base_url + 'PaymentInvoice/GenerateInvoice',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };



            axios(api_config)
                .then(function (response) {
                    //console.log(response.data);
                    if (response.data.status_code == 1) {

                        toast.success(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });

                    }
                    else {
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                    }

                    setLoading(false);


                })
                .catch(function (error) {
                    setLoading(false);
                    toast.error('Network Error..', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                });



        }

        setValidated(true);
    };


    return (
        <>
            <InvoiceMenu />
            <ToastContainer />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"> <Link to="/invoice/manage-invoice">Invoice</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Add Invoice</li>
                                </ol>
                            </nav>
                            <div className="page-title">Add Invoice</div>
                        </div>
                        <div className="col-md-6">
                            <div className="page-right-actions">
                                <Link to="/invoice/manage-invoice" className="button button-white button-icon">
                                    Manage Invoice
                                    <i className="ri-list-check"></i>
                                </Link>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                        <div className="row align-items-center">
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label className="">Invoice Month:</label>
                                                    <select className="form-select" required name="InvoiceMonth" defaultValue="">
                                                        <option value="">Please Select</option>
                                                        <MonthsDropDown />
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label className="">Invoice Year:</label>
                                                    <select className="form-select" required name="InvoiceYear" defaultValue="">
                                                        <option value="">Please Select</option>
                                                        <YearsDropDown />
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label className="">Invoice Amount:</label>
                                                    <input type="number" className="form-control" required name="InvoiceAmount" min="0" />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label className="">Generated Date:</label>
                                                    <input type="date" className="form-control" required name="GeneratedDate" defaultValue={todayDate} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label className="">Invoice Status:</label>
                                                    <select className="form-select" required name="InvoiceStatus" defaultValue="Generated">
                                                        <option value="Generated">Generated</option>
                                                        <option value="Draft">Draft</option>
                                                        <option value="Cancelled">Cancelled</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label className="">Payment Status:</label>
                                                    <select className="form-select" required name="PaymentStatus" defaultValue="Pending">
                                                        <option value="Pending">Pending</option>
                                                        <option value="Paid">Paid</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="">Admin Remarks:</label>
                                                    <input type="text" className="form-control" name="AdminRemarks" />
                                                </div>
                                            </div>
                                            <div className="col-md-2 mt-md-2 text-end">
                                                <div className="form-group ">
                                                    {
                                                        loading ?
                                                            <Spinner animation="border" role="status"></Spinner>

                                                            :
                                                            <button type="submit" value="Save" className="button button-primary w-100 ">SAVE</button>

                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddInvoice;
